"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

const HyperLink = props => {
  const {
    children,
    Link,
    link
  } = props,
        otherProps = (0, _objectWithoutProperties2.default)(props, ["children", "Link", "link"]);
  const ExternalLink = Link || link;
  return ExternalLink ? /*#__PURE__*/_react.default.createElement(ExternalLink, otherProps, children) : /*#__PURE__*/_react.default.createElement("a", otherProps, children);
};

HyperLink.propTypes = {
  children: _propTypes.default.node,
  Link: _propTypes.default.func,
  link: _propTypes.default.func,
  href: _propTypes.default.string.isRequired,
  className: _propTypes.default.string,
  rel: _propTypes.default.string,
  target: _propTypes.default.string
};
HyperLink.defaultProps = {
  children: null,
  Link: null,
  link: null,
  className: undefined,
  rel: undefined,
  target: undefined
};
var _default = HyperLink;
exports.default = _default;